import { useEffect } from "react"
import { Box, Typography } from "@mui/material";
import { translate } from "react-i18nify";
import { colors } from "../../Style";

export const NewPatientPopup = (props) => {

    const navigation = (navigatior, action, menu, state) => {
        if(action.type === "CLICK"){
            switch(menu[action.button].route){
                case "NAVIGATE_CANCEL":
                    props.onCancel()
                    break
                case "NAVIGATE_SELECT": 
                    props.onComplete()
                    break   
            }
        }
    }

    const defaultState = {
        name: props.name,
        label: props.label,
        windowNavigation: navigation,
        };

    const menu = props.menu ? 
        props.menu
        : {
            LEFT: { label: "No", route: "NAVIGATE_CANCEL", local: true },
            RIGHT: { label: "Yes", route: "NAVIGATE_SELECT", local: true },
            UP: null,
            MIDDLE: null,
            DOWN: null,
        };

    const windowState = props?.state ? 	
        {
            ...props.state,
            menu: menu,
            label: props.label,
        }
        : defaultState;

    const setWindowState = (windowState) => {
        props.setState(windowState.menu, windowState);
    };

    useEffect(() => {
        // if (true) {
        // }
        windowState.windowNavigation = navigation;
        props.setState(menu, windowState);
    }, [windowState.name]);

  return (
    <Box
      sx={{
        width: "450px",
        height: "90px",
        background: "black",
        border: "1px solid white",
        p: 1,
        position: "relative", zIndex: 105,
      }}
    >
        {/* <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        </Box> */}
        <Box
            sx={{ position: "relative", zIndex: 510, mt: 2, width: "100%", display: "flex", justifyContent: "center", }}
        >
            <Typography variant="h6" sx={{color:colors().COLORS_CUSTOMPROFILE, fontWeight: "bold" }}>
                {translate(props.label)}
            </Typography>
        </Box>
    </Box>
  );
}